/**
 * Config for the cryptonetwork.g1.network console.
 *
 * Cookie-SSO like every other platform SPA (CRM, tasks, …): the g1_access
 * cookie is shared on `.g1.network`, so requests go same-origin with
 * credentials; the shared operator shell (@theg1group/app-shell) handles the
 * auth gate + redirect to auth.g1.network. API is served same-origin by the
 * Worker, so the base is relative.
 */
const PLATFORM_APEXES = ["g1.network", "g1network.dev"] as const;

function platformApex(): string | null {
	if (typeof window === "undefined") return null;
	const h = window.location.hostname;
	for (const a of PLATFORM_APEXES) if (h === a || h.endsWith(`.${a}`)) return a;
	return null;
}
const APEX = platformApex();

/** Same-origin API (Worker serves /api/* on this host). */
export const API_BASE = import.meta.env.VITE_API_BASE ?? "";

/** Shared-api (single JWT signer) — for /auth/refresh. */
export const SHARED_API_URL = APEX
	? `https://api.${APEX}`
	: (import.meta.env.VITE_SHARED_API_URL ?? "https://api.g1.network");

export const AUTH_URL = APEX
	? `https://auth.${APEX}`
	: (import.meta.env.VITE_AUTH_URL ?? "https://auth.g1.network");
